module.exports = __webpack_public_path__ + "static/media/Korea Exhibition_Robert, Erick_Final Version_H264. Stereo.b3a7594b.mp4";